import React from 'react';
import { ShareTargetType } from '../data/ShareTargetType';
import ShareTargetCheckbox from './ShareTargetCheckbox';
import ReviewStepHeader from '../UI/ReviewStepHeader';
import { useUserReviewEditor } from '../data/UserReviewEditorProvider';
import './nominationsEditor.css';

export default function NominationsEditor() {
	const { nominationTargetsEditor } = useUserReviewEditor();
	const { getOptions, isNominationSubmitted } = nominationTargetsEditor;

	const nominationOptions = getOptions();

	const renderNominationCheckbox = nominationOption => {
		const shareTarget = {
			id: nominationOption.submissionListId,
			type: ShareTargetType.nomination,
		};

		const isSubmitted = isNominationSubmitted(
			nominationOption.submissionListId,
		);

		return (
			<ShareTargetCheckbox
				key={nominationOption.submissionListId}
				shareTarget={shareTarget}
				isDisabled={isSubmitted}
				shareTargetsEditor={nominationTargetsEditor}>
				{nominationOption.name}
			</ShareTargetCheckbox>
		);
	};

	return (
		<div className="nominations-editor-root editor-root">
			<div className="nominations-editor">
				<ReviewStepHeader label="Nominate" icon="trophy" />
				<div className="checkbox-container">
					<div className="checkbox-wrapper">
						{nominationOptions.map(renderNominationCheckbox)}
					</div>
				</div>
			</div>
		</div>
	);
}
